import { useEffect } from 'react';
import { MODAL } from '../../context';
import { useApp } from '../useApp';
import { usePageOwner } from '../usePageOwner';

interface UseOpenDonateToYourselfModal {
  totalDonationAmount?: number;
}

export function useOpenDonateToYourselfModal({
  totalDonationAmount,
}: UseOpenDonateToYourselfModal) {
  const { isPageOwner } = usePageOwner();

  const { showModal } = useApp();
  const urlParams = new URLSearchParams(
    typeof window !== 'undefined' ? window.location.search : '',
  );
  const isNewPage = Boolean(urlParams.get('newPage'));

  const isNotOwnerOrNewPage = !isPageOwner || !isNewPage;

  useEffect(() => {
    if (isNotOwnerOrNewPage) return;

    showModal({ modal: MODAL.DONATE_TO_YOURSELF });
  }, [isNotOwnerOrNewPage, showModal]);
}
